import { urls } from './site';
import type { Capability, Service } from '../types/site';

export const services: Service[] = [
  {
    number: '01',
    title: 'Truck Collision Repair',
    description: 'Body and panel repair for commercial trucks damaged in a collision.',
    href: urls.collision,
    linkLabel: 'Truck collision repair',
    icon: 'collision',
  },
  {
    number: '02',
    title: 'Semi Truck Body Repair',
    description: 'Cab, hood and body collision repairs for semi tractors.',
    href: urls.semi,
    linkLabel: 'Semi truck repair',
    icon: 'semi',
  },
  {
    number: '03',
    title: 'Box Truck Repair',
    description: 'Roofs, walls, floors, doors and collision-damaged bodies.',
    href: urls.boxTruck,
    linkLabel: 'Box truck repair',
    icon: 'boxTruck',
  },
  {
    number: '04',
    title: 'Commercial Truck Painting',
    description: 'Collision refinishing and commercial paint for working trucks.',
    href: urls.paint,
    linkLabel: 'Paint shop',
    icon: 'paint',
  },
  {
    number: '05',
    title: 'Fleet Body Repair',
    description: 'Bodywork and paint for fleet units, matched to your fleet colors.',
    href: urls.fleet,
    linkLabel: 'Fleet repair',
    icon: 'fleet',
  },
  {
    number: '06',
    title: 'Trailer & RV Body Repair',
    description: 'Body and roof repair for trailers and RVs.',
    href: urls.trailerOverview,
    linkLabel: 'Trailer & RV repair',
    icon: 'trailer',
  },
];

export const additionalCapabilities: Capability[] = [
  { label: 'Service bodies', href: urls.serviceBody },
  { label: 'Liftgate body repairs', href: urls.liftgate },
  { label: 'Wraps', href: urls.wraps },
  { label: 'Sandblasting', href: urls.blasting },
  { label: 'Heavy equipment restoration & painting', href: urls.heavyEquipment },
];
